var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sidebar-video-recording",class:_vm.isSidebarMinimized ? 's-minimized' : ''},[_c('i',{staticClass:"c-sidebar-nav-icon cil-video"}),_vm._v(" "),_c('div',{staticClass:"video-screen-recording-container"},[_c('VideoScreenRecording',{attrs:{"canvas-id":"recordScreenAndVideoCanvasGlobal"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }